import React from 'react';

interface IVanIconProps {
	size?: string;
	active?: boolean;
}

export const Van = ({ size = '106', active = false }: IVanIconProps) => {
	return active ? (
		<svg role="img" width={size} height={size} viewBox="0 0 108 106" fill="none" aria-labelledby="vanActiveTitle">
			<title id="vanActiveTitle">camper van illustration</title>
			<path
				d="M105.75 68.9333V72.9853C106.038 72.9849 106.316 73.1096 106.525 73.3335C106.735 73.5574 106.86 73.8635 106.874 74.1882V79.2531C106.859 80.216 106.509 81.1338 105.899 81.8088C105.29 82.4838 104.469 82.862 103.614 82.8619H2.76807V44.4318C2.76807 43.2564 3.18264 42.1292 3.92057 41.2981C4.65851 40.4669 5.65936 40 6.70296 40H71.1124C76.278 40 84.3889 50.6997 84.3889 50.6997L95.9688 62.349L103.445 65.3246C104.117 65.5773 104.701 66.0619 105.115 66.7096C105.529 67.3574 105.751 68.1354 105.75 68.9333Z"
				fill="#F9F9F9"
				stroke="#707070"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path d="M76.2241 65.5828V67.856" stroke="#707070" strokeWidth="2" strokeLinejoin="round" />
			<path
				d="M72.8381 47.7893H67.3039C66.4172 47.7893 65.5668 48.2494 64.9397 49.0683C64.3127 49.8872 63.9604 50.9979 63.9604 52.156V62.1371H87.0068C87.0068 62.1371 75.2671 49.4388 74.7486 48.803C74.2301 48.1672 73.5492 47.8059 72.8381 47.7893Z"
				fill="#ffcc00"
				stroke="#707070"
				strokeWidth="2"
			/>
			<path
				d="M106.079 73.2966H103.237C102.937 73.2966 102.65 73.166 102.437 72.9336C102.225 72.7011 102.106 72.3859 102.106 72.0572V71.29C102.106 71.1299 102.135 70.9714 102.193 70.8242C102.25 70.677 102.335 70.5442 102.44 70.4338C102.546 70.3233 102.671 70.2377 102.808 70.182C102.945 70.1262 103.091 70.1016 103.237 70.1096H105.285"
				stroke="#707070"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path d="M1 90L107 89.5542" stroke="#707070" strokeWidth="2" strokeLinejoin="round" />
			<path
				d="M81.4439 67.1484V62.1372H63.9604V74.7765C63.9604 75.4411 64.2533 76.0784 64.7747 76.5483C65.2961 77.0182 66.0032 77.2821 66.7405 77.2821H73.9687C74.706 77.2821 75.4131 77.0182 75.9344 76.5483C76.4558 76.0784 76.7487 75.4411 76.7487 74.7765V74.3868C76.7343 73.197 77.1701 72.0383 77.9843 71.1017L81.4439 67.1484Z"
				fill="#DDDDDD"
				stroke="#707070"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M80.021 63.562H82.2028C82.9392 63.562 83.5361 62.9471 83.5361 62.1886C83.5361 61.4301 82.9392 60.8151 82.2028 60.8151H80.021C79.2846 60.8151 78.6876 61.4301 78.6876 62.1886C78.6876 62.9471 79.2846 63.562 80.021 63.562Z"
				fill="#F9F9F9"
				stroke="#707070"
				strokeWidth="2"
			/>
			<path
				d="M2.76807 69.311H4.03959C4.54543 69.311 5.03056 69.5099 5.38824 69.864C5.74593 70.218 5.94687 70.6982 5.94687 71.1989V76.9884C5.94687 77.4891 5.74593 77.9693 5.38824 78.3233C5.03056 78.6773 4.54543 78.8763 4.03959 78.8763H2.76807V69.311Z"
				stroke="#707070"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M57.6025 47.7893H20.2515V62.1371H57.6025V47.7893Z"
				fill="#ffcc00"
				stroke="#777777"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M26.5 88C30.6421 88 34 84.6421 34 80.5C34 76.3579 30.6421 73 26.5 73C22.3579 73 19 76.3579 19 80.5C19 84.6421 22.3579 88 26.5 88Z"
				fill="white"
				stroke="#707070"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M26.5 86C29.5376 86 32 83.5376 32 80.5C32 77.4624 29.5376 75 26.5 75C23.4624 75 21 77.4624 21 80.5C21 83.5376 23.4624 86 26.5 86Z"
				fill="#EFEFEF"
			/>
			<path
				d="M23 80.7825C23.0024 81.5818 23.2486 82.3597 23.7031 83.0046C24.1577 83.6496 24.7973 84.1283 25.53 84.3722"
				stroke="#707070"
				strokeWidth="2"
				strokeLinejoin="round"
			/>
			<path
				d="M30.158 81.744C30.2592 81.435 30.3011 81.1083 30.2814 80.7825C30.2898 80.2835 30.2013 79.7878 30.0213 79.325C29.8413 78.8622 29.5734 78.4419 29.2337 78.0889C28.8939 77.736 28.4892 77.4577 28.0437 77.2708C27.5982 77.0838 27.121 76.9919 26.6406 77.0006"
				stroke="#707070"
				strokeWidth="2"
				strokeLinejoin="round"
			/>
			<path
				d="M88.5 88C92.6421 88 96 84.6421 96 80.5C96 76.3579 92.6421 73 88.5 73C84.3579 73 81 76.3579 81 80.5C81 84.6421 84.3579 88 88.5 88Z"
				fill="white"
				stroke="#707070"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M88.5 86C91.5376 86 94 83.5376 94 80.5C94 77.4624 91.5376 75 88.5 75C85.4624 75 83 77.4624 83 80.5C83 83.5376 85.4624 86 88.5 86Z"
				fill="#EFEFEF"
			/>
			<path
				d="M85 80.7825C85.0024 81.5818 85.2486 82.3597 85.7031 83.0046C86.1577 83.6496 86.7973 84.1283 87.53 84.3722"
				stroke="#707070"
				strokeWidth="2"
				strokeLinejoin="round"
			/>
			<path
				d="M92.158 81.744C92.2592 81.435 92.3011 81.1083 92.2814 80.7825C92.2898 80.2835 92.2013 79.7878 92.0213 79.325C91.8413 78.8622 91.5734 78.4419 91.2337 78.0889C90.8939 77.736 90.4892 77.4577 90.0437 77.2708C89.5982 77.0838 89.121 76.9919 88.6406 77.0006"
				stroke="#707070"
				strokeWidth="2"
				strokeLinejoin="round"
			/>
			<path d="M1 31H6" stroke="#707070" strokeWidth="2" />
			<path d="M9 31H23" stroke="#707070" strokeWidth="2" />
			<path d="M33 23H51" stroke="#707070" strokeWidth="2" />
		</svg>
	) : (
		<svg role="img" width={size} height={size} viewBox="0 0 108 106" fill="none" aria-labelledby="vanTitle">
			<title id="vanTitle">camper van illustration</title>
			<path
				d="M105.75 68.9333V72.9853C106.039 72.9849 106.316 73.1096 106.526 73.3335C106.735 73.5574 106.86 73.8635 106.874 74.1882V79.2531C106.86 80.216 106.51 81.1338 105.9 81.8088C105.29 82.4838 104.469 82.862 103.614 82.8619H2.76831V44.4318C2.76831 43.2564 3.18288 42.1292 3.92082 41.2981C4.65875 40.4669 5.6596 40 6.7032 40H71.1127C76.2782 40 84.3892 50.6997 84.3892 50.6997L95.969 62.349L103.445 65.3246C104.117 65.5773 104.702 66.0619 105.115 66.7096C105.529 67.3574 105.751 68.1354 105.75 68.9333Z"
				fill="#F9F9F9"
				stroke="#A6A6A6"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path d="M76.2239 65.5828V67.8561" stroke="#A6A6A6" strokeWidth="2" strokeLinejoin="round" />
			<path
				d="M72.8378 47.7894H67.3037C66.417 47.7894 65.5665 48.2495 64.9395 49.0684C64.3125 49.8873 63.9602 50.998 63.9602 52.1561V62.1372H87.0066C87.0066 62.1372 75.2669 49.4389 74.7484 48.8031C74.2299 48.1673 73.5489 47.806 72.8378 47.7894Z"
				fill="white"
				stroke="#A6A6A6"
				strokeWidth="2"
			/>
			<path
				d="M106.079 73.2967H103.237C102.937 73.2967 102.65 73.1661 102.437 72.9337C102.225 72.7012 102.106 72.386 102.106 72.0573V71.2901C102.106 71.13 102.135 70.9715 102.193 70.8243C102.25 70.6771 102.335 70.5443 102.44 70.4338C102.546 70.3234 102.671 70.2378 102.808 70.1821C102.945 70.1263 103.091 70.1017 103.237 70.1097H105.285"
				stroke="#A6A6A6"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path d="M1 90L107 89.5542" stroke="#A6A6A6" strokeWidth="2" strokeLinejoin="round" />
			<path
				d="M81.4436 67.1484V62.1372H63.9602V74.7766C63.9602 75.4411 64.2531 76.0784 64.7744 76.5483C65.2958 77.0182 66.0029 77.2822 66.7403 77.2822H73.9684C74.7057 77.2822 75.4128 77.0182 75.9342 76.5483C76.4555 76.0784 76.7485 75.4411 76.7485 74.7766V74.3868C76.734 73.197 77.1698 72.0383 77.984 71.1017L81.4436 67.1484Z"
				fill="#DDDDDD"
				stroke="#A6A6A6"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M80.021 63.5621H82.2028C82.9392 63.5621 83.5361 62.9472 83.5361 62.1887C83.5361 61.4302 82.9392 60.8153 82.2028 60.8153H80.021C79.2846 60.8153 78.6876 61.4302 78.6876 62.1887C78.6876 62.9472 79.2846 63.5621 80.021 63.5621Z"
				fill="#F9F9F9"
				stroke="#A6A6A6"
				strokeWidth="2"
			/>
			<path
				d="M2.76831 69.3111H4.03983C4.54568 69.3111 5.0308 69.51 5.38849 69.8641C5.74617 70.2181 5.94712 70.6983 5.94712 71.199V76.9885C5.94712 77.4892 5.74617 77.9694 5.38849 78.3234C5.0308 78.6775 4.54568 78.8764 4.03983 78.8764H2.76831V69.3111Z"
				stroke="#A6A6A6"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M57.6027 47.7894H20.2517V62.1372H57.6027V47.7894Z"
				fill="white"
				stroke="#A6A6A6"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M26.5 88C30.6421 88 34 84.6421 34 80.5C34 76.3579 30.6421 73 26.5 73C22.3579 73 19 76.3579 19 80.5C19 84.6421 22.3579 88 26.5 88Z"
				fill="white"
				stroke="#A6A6A6"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M26.5 86C29.5376 86 32 83.5376 32 80.5C32 77.4624 29.5376 75 26.5 75C23.4624 75 21 77.4624 21 80.5C21 83.5376 23.4624 86 26.5 86Z"
				fill="#EFEFEF"
			/>
			<path
				d="M23 80.7825C23.0024 81.5818 23.2486 82.3597 23.7031 83.0046C24.1577 83.6496 24.7973 84.1283 25.53 84.3722"
				stroke="#A6A6A6"
				strokeWidth="2"
				strokeLinejoin="round"
			/>
			<path
				d="M30.1583 81.744C30.2594 81.435 30.3014 81.1083 30.2817 80.7825C30.29 80.2835 30.2016 79.7878 30.0216 79.325C29.8416 78.8622 29.5737 78.4419 29.2339 78.0889C28.8942 77.736 28.4895 77.4577 28.044 77.2708C27.5985 77.0838 27.1213 76.9919 26.6409 77.0006"
				stroke="#A6A6A6"
				strokeWidth="2"
				strokeLinejoin="round"
			/>
			<path
				d="M88.5 88C92.6421 88 96 84.6421 96 80.5C96 76.3579 92.6421 73 88.5 73C84.3579 73 81 76.3579 81 80.5C81 84.6421 84.3579 88 88.5 88Z"
				fill="white"
				stroke="#A6A6A6"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M88.5 86C91.5376 86 94 83.5376 94 80.5C94 77.4624 91.5376 75 88.5 75C85.4624 75 83 77.4624 83 80.5C83 83.5376 85.4624 86 88.5 86Z"
				fill="#EFEFEF"
			/>
			<path
				d="M85 80.7825C85.0024 81.5818 85.2486 82.3597 85.7031 83.0046C86.1577 83.6496 86.7973 84.1283 87.53 84.3722"
				stroke="#A6A6A6"
				strokeWidth="2"
				strokeLinejoin="round"
			/>
			<path
				d="M92.1583 81.744C92.2594 81.435 92.3014 81.1083 92.2817 80.7825C92.29 80.2835 92.2016 79.7878 92.0216 79.325C91.8416 78.8622 91.5737 78.4419 91.2339 78.0889C90.8942 77.736 90.4895 77.4577 90.044 77.2708C89.5985 77.0838 89.1213 76.9919 88.6409 77.0006"
				stroke="#A6A6A6"
				strokeWidth="2"
				strokeLinejoin="round"
			/>
			<path d="M1 31H6" stroke="#A6A6A6" strokeWidth="2" />
			<path d="M9 31H23" stroke="#A6A6A6" strokeWidth="2" />
			<path d="M33 23H51" stroke="#A6A6A6" strokeWidth="2" />
		</svg>
	);
};
